<!-- Footer -->
<div class="padding-20"></div>
<div class="img-contain" *ngIf="footer.visible">
  <img src="../../../assets/images/SuscribeUS.png" alt="SuscribeUS image" class="img-responsive" width="580" height="420">
  <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-around center" fxHide.lt-md="true" class="img-content">
    <div fxFlex="15"></div>
    <div fxFlex="50" fxFlexOffset="">
      <div>
        <div class="suscribe blink_me">Subscribe Us, We Will Contact You Shortly!</div><br>
        <form [formGroup]="subscribeForm" autocomplete="off" fxLayout="column">
          <mat-form-field>
            <mat-label>Email</mat-label>
            <input matInput placeholder="Email" formControlName="email" required/>
            <mat-icon matSuffix>email</mat-icon>
            <mat-error>Email is required</mat-error>
          </mat-form-field>
        </form>
        <div mat-dialog-actions class="submit_button">
          <button mat-raised-button mat-dialog-close (click)="submitForm()" [disabled]="subscribeForm.invalid" color="warn">
            Subscribe
          </button>
        </div>
      </div>
      <!-- <p class="mat-title bold text_color1">Health Cloud allows healthcare providers to create a unified 
        view of each patient, consolidating medical records, appointments, 
        care plans, and other relevant information.</p> -->
  </div>
  <div fxFlex="15"></div>
</div>
</div>

<mat-card class="header" fxShow.lt-md="true" fxHide="true">
    <div style="padding:5%;">
      <div class="mat-display-1" style="text-align: center;">Subscribe Us, We Will Contact You Shortly!</div>
      <form [formGroup]="subscribeForm" autocomplete="off" fxLayout="column">
        <mat-form-field>
          <mat-label>Email</mat-label>
          <input matInput placeholder="Email" formControlName="email" required/>
          <mat-icon matSuffix>email</mat-icon>
          <mat-error>Email is required</mat-error>
        </mat-form-field>
      </form>
      <div mat-dialog-actions class="submit_button">
        <button mat-raised-button mat-dialog-close (click)="submitForm()" [disabled]="subscribeForm.invalid" color="warn">
          Subscribe
        </button>
      </div>
    </div>
</mat-card>
 

<!-- <section class="section">
  <div class="section" *ngIf="footer.visible">
    <div class="padding-20"></div>
    <div class="padding-20"></div>

    <div class="padding-20">
      <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="5%" fxLayoutAlign="space-around center">
        <div fxFlex="45" >
          <mat-card>
            <div class="mat-display-5">Subscribe Us!</div>
            <form [formGroup]="subscribeForm" autocomplete="off" fxLayout="column">
              <mat-form-field>
                <mat-label>Email</mat-label>
                <input matInput placeholder="Email" formControlName="email" required/>
                <mat-icon matSuffix>email</mat-icon>
                <mat-error>Email is required</mat-error>
              </mat-form-field>
            </form>
            <div mat-dialog-actions class="submit_button">
              <button mat-raised-button mat-dialog-close (click)="submitForm()" [disabled]="subscribeForm.invalid" color="warn">
                Subscribe
              </button>
            </div>
          </mat-card>
        </div>
      </div>
      <div class="padding-20"></div>
    </div>
  </div>
</section> -->

<div class="gdpr padding-20" *ngIf="showGDPR">
  <div fxLayout="row" fxLayout.lt-md="column">
    <div fxFlex="80" fxFlex.xs="100" style="margin-top: 10px" class="content-view-light bold">
      This website uses cookies to ensure you get the best experience on our
      website. <a routerLink="/cookie-policy">Read more</a>
    </div>
    <div fxFlex="20" fxFlex.xs="100">
      <br/>
      <button (click)="gdpr()" mat-raised-button color="warn" fxShow="true" fxHide.lt-sm="true" class="bold">
        Allow Cookies
      </button>
      <button (click)="gdpr()" mat-raised-button color="accent" fxHide="true" fxShow.lt-sm="true" class="mobile-cookie-view">
        Allow Cookies
      </button>
    </div>
  </div>
</div>
<br><br>
<div class="footer-container footer-background" *ngIf="footer.visible">
  <div>
    <footer>
      <div fxLayout="row" fxLayout.xs="column">
        <div fxFlex="25" fxFlex.sm="100">
          <div class="company-details text-center">
            <div class="company-logo">
              <img height="100" width="100" src="../../../assets/images/BANCOM-header-logo.png" />
              <br />
              <h6><b>BANCOM.IO</b></h6>
            </div>
            <div class="copyright">
              <p class="footer-content-text">
                © Copyright 2020-2021, <b>BANCOM.IO</b><br />
                All rights reserved.</p>
            </div>
          </div>
        </div>
<div fxHide="true" fxShow.lt-md="true">
  <div fxFlex="55">
    <div class="information">

      <h6 class="footer-content-heading bold">Information</h6>
      <ul class="ul-legal">
        <li>
          <a routerLink="/security-statement" class="footer-content-text">
            <button mat-mini-fab color="accent" aria-label="Security Statement" class="iconsColor">
              <i class="fa fa-shield"></i>
            </button>
            &nbsp; Security Statement</a>
        </li>
        <li>
          <a routerLink="/privacy-policy" class="footer-content-text">
            <button mat-mini-fab color="accent" aria-label="Privacy Policy" class="iconsColor">
              <i class="fa fa-user-secret"></i>
            </button>
            &nbsp; Privacy Policy</a>
        </li>

        <li>
          <a routerLink="/cookie-policy" class="footer-content-text">
            <button mat-mini-fab color="accent" aria-label="Cookie Policy" class="iconsColor">
              <mat-icon style="font-size: 17px; margin-top: 14%;">group_work</mat-icon>
            </button>
            &nbsp; Cookie Policy</a>
        </li>
      </ul>
  
        <!-- <li>
          <a routerLink="/jobs" class="footer-content-text">
            <button mat-mini-fab color="accent" aria-label="About us" class="iconsColor">
              <mat-icon>work</mat-icon>
            </button>&nbsp; Jobs
          </a>
        </li> -->
      
    </div>
  </div>


  <div fxFlex="50">
    <div class="social-icons">
      <h6 class="footer-content-heading bold">We are Social</h6>
      <a href="https://fb.me/bancom.io" target="_blank" class="footer-content-text">
        <button mat-mini-fab color="accent" aria-label="Facebook Icon" class="iconsColor">
          <i class="fa fa-facebook"></i>
        </button>
      </a>
      &nbsp;&nbsp;
      <a href="https://twitter.com/bancom_io" target="_blank" class="footer-content-text">
        <button mat-mini-fab color="accent" aria-label="Twitter Icon" class="iconsColor">
          <i class="fa fa-twitter"></i>
        </button>
      </a>
      &nbsp;&nbsp;
      <a href="https://www.linkedin.com/company/bancomio/" target="_blank" class="footer-content-text">
        <button mat-mini-fab color="accent" aria-label="LinkedIn Icon" class="iconsColor">
          <i class="fa fa-linkedin"></i>
        </button>
      </a>

    </div>
    <div class="social-icons">
      <a href="https://www.youtube.com/channel/UC8lJKSZkazU7dtX1JdOZctw/about" target="_blank"
      class="footer-content-text">
      <button mat-mini-fab color="accent" aria-label="Youtube Icon" class="iconsColor">
        <i class="fa fa-youtube"></i>
      </button>
    </a>
    &nbsp;&nbsp;
    <a href="https://www.instagram.com/bancom.io/" target="_blank" class="footer-content-text">
      <button mat-mini-fab color="accent" aria-label="Instagram Icon" class="iconsColor">
        <i class="fa fa-instagram"></i>
      </button>
    </a>
    </div>
    <br />
    <h6 class="footer-content-heading bold">&nbsp;Life@BANCOM</h6>
      <ul class="ul-legal">
        <li>
          <a routerLink="/about" class="footer-content-text">
            <button mat-mini-fab color="accent" aria-label="About us" class="iconsColor">
              <i class="fa fa-user"></i></button>&nbsp; About us
          </a>
        </li>
      </ul>
  </div>
</div>
        <div fxFlex="25" fxFlex.gt-sm="50" fxFlex.sm="100" fxShow="true" fxHide.lt-md="true">
          <div class="information">

            <h6 class="footer-content-heading">Information</h6>
            <ul class="ul-legal">
              <li>
                <a routerLink="/security-statement" class="footer-content-text">
                  <button mat-mini-fab color="accent" aria-label="Security Statement" class="iconsColor">
                    <i class="fa fa-shield"></i>
                  </button>
                  &nbsp; Security Statement</a>
              </li>
              <li>
                <a routerLink="/privacy-policy" class="footer-content-text">
                  <button mat-mini-fab color="accent" aria-label="Privacy Policy" class="iconsColor">
                    <i class="fa fa-user-secret"></i>
                  </button>
                  &nbsp; Privacy Policy</a>
              </li>

              <li>
                <a routerLink="/cookie-policy" class="footer-content-text">
                  <button mat-mini-fab color="accent" aria-label="Cookie Policy" class="iconsColor">
                    <mat-icon style="font-size: 17px; margin-top: 14%;">group_work</mat-icon>
                  </button>
                  &nbsp; Cookie Policy</a>
              </li>
            </ul>
          </div>
        </div>

        <div fxFlex="20" fxFlex.gt-sm="50" fxFlex.sm="100" fxShow="true" fxHide.lt-md="true">
          <div class="social-icons">
            <h6 class="footer-content-heading">We are Social</h6>
            <a href="https://fb.me/bancom.io" target="_blank" class="footer-content-text">
              <button mat-mini-fab color="accent" aria-label="Facebook Icon" class="iconsColor">
                <i class="fa fa-facebook"></i>
              </button>
            </a>
            &nbsp;
            <a href="https://twitter.com/bancom_io" target="_blank" class="footer-content-text">
              <button mat-mini-fab color="accent" aria-label="Twitter Icon" class="iconsColor">
                <i class="fa fa-twitter"></i>
              </button>
            </a>
            &nbsp;
            <a href="https://www.linkedin.com/company/bancomio/" target="_blank" class="footer-content-text">
              <button mat-mini-fab color="accent" aria-label="LinkedIn Icon" class="iconsColor">
                <i class="fa fa-linkedin"></i>
              </button>
            </a>
          </div>
          <div class="social-icons">
            <a href="https://www.youtube.com/channel/UC8lJKSZkazU7dtX1JdOZctw/about" target="_blank"
              class="footer-content-text">
              <button mat-mini-fab color="accent" aria-label="Youtube Icon" class="iconsColor">
                <i class="fa fa-youtube"></i>
              </button>
            </a>
            &nbsp;
            <a href="https://www.instagram.com/bancom.io/" target="_blank" class="footer-content-text">
              <button mat-mini-fab color="accent" aria-label="Instagram Icon" class="iconsColor">
                <i class="fa fa-instagram"></i>
              </button>
            </a>
          </div>
          <br/>
            <h6 class="footer-content-heading">&nbsp;&nbsp;Life@BANCOM</h6>
            <ul class="ul-legal">
              <li>
                <a routerLink="/about" class="footer-content-text">
                  <button mat-mini-fab color="accent" aria-label="About us" class="iconsColor">
                    <i class="fa fa-user"></i></button>&nbsp; About us
                </a>
              </li>
            </ul>
        </div>
        <div fxFlex="30" fxFlex.gt-sm="50" fxFlex.sm="100">
          <div class="needHelp">
            <h6><a class="footer-content-heading importantLink" routerLink="/corporate-programs">Corporate Trainings</a></h6>
            <p class="footer-content-text">Elevate your team with transformative corporate training that sparks growth and fuels success.</p>
          </div>
          <!--<div class="needHelp">
            <h6><a class="footer-content-heading importantLink" routerLink="/corporate-hirings">Corporate Hirings</a></h6>
            <p class="footer-content-text">Unleash your organization's potential with our game-changing corporate hiring program.</p>
          </div>-->
          <div class="needHelp">
            <h6><a class="footer-content-heading importantLink" routerLink="/contact-us">Contact Us</a></h6>
            <p class="footer-content-text">Need Help? If you can't find what you're looking for.</p>
          </div>
          <div class="reportBug">
            <h6><a class="footer-content-heading importantLink" routerLink="/report-bug">Report Bug</a></h6>
            <p class="footer-content-text">We are committed to better User Experience</p>

          </div>
          <!-- <div class="buildForYou">
            <h6><a class="footer-content-heading importantLink" routerLink="/request-quote">Build for You</a></h6>
            <p class="footer-content-text">If you want us to build something awesome for you, let us know</p>
          </div> -->
        </div>
      </div>
      <!-- <div fxLayout="column">
        <div fxFlex="100"></div>
      </div> -->
    </footer>
  </div>
</div>
